import styled from 'styled-components';

export const MatchRowWrapper = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${props => props.theme.colors.borderColor};
  border-radius: 0.1em;
  margin: 0 auto 0.4em;
  min-height: 4em;
  width: 100%;
  padding: 0.5em 0;
  
  &.no-event{
    pointer-events: none;
    .icon-matchcenter-right-arrow{
      display: none;
    }
  };
  
  &:hover {
    background: ${props => props.theme.colors.hoverColor};
    border-color: ${props => props.theme.colors.hoverBorderColor};
  };
`;

export const MatchStatsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    flex-direction: row;
    margin-bottom: 3px;
    margin-left: -19px;
  }
`;

export const BetWrapper = styled.div`
  width: 100%;
  margin-bottom: -0.5em;
  margin-top: 0.6em;
`;



// WEBPACK FOOTER //
// ./src/components/MatchRowFav/styles.js